"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RefProgramPopUp = void 0;
const common_1 = require("@app/components/common");
const react_1 = __importStar(require("react"));
const Yup = __importStar(require("yup"));
const RefProgramPopUp_elements_1 = require("./RefProgramPopUp.elements");
const buttons_1 = require("@components/buttons");
const formik_1 = require("formik");
const validationSchema_1 = require("@app/helpers/validationSchema");
const classnames_1 = __importDefault(require("classnames"));
const Landing_1 = require("@app/routes/Landing");
const RefProgramPopUp_translations_1 = require("./RefProgramPopUp.translations");
const apiFetch_1 = require("@app/utils/apiFetch");
const RefProgramPopUp = ({ onClose }) => {
    const language = (0, react_1.useContext)(Landing_1.LanguageContext);
    const t = RefProgramPopUp_translations_1.translations[language];
    const formik = (0, formik_1.useFormik)({
        initialValues: {
            emailForRef: "",
        },
        validateOnBlur: true,
        validateOnMount: true,
        validationSchema: Yup.object({
            emailForRef: validationSchema_1.emailValidationSchema,
        }),
        onSubmit: (values) => {
            (0, apiFetch_1.apiFetch)("/pdf_to_email/", {
                method: "POST",
                body: JSON.stringify({ email: values.emailForRef }),
            })
                .then((response) => {
                if (response.ok) {
                    onClose();
                }
                else {
                    formik.setErrors({ emailForRef: "send-fail" });
                }
            })
                .catch(() => {
                formik.setErrors({ emailForRef: "send-fail" });
            });
        },
    });
    return (react_1.default.createElement(common_1.PopUp, { title: t.title, onClose: onClose },
        react_1.default.createElement(RefProgramPopUp_elements_1.RefProgramPopUpContent, { onSubmit: formik.handleSubmit },
            react_1.default.createElement("div", { className: "divs-input email-div" },
                react_1.default.createElement("input", Object.assign({ type: "text", autoComplete: "enter-your-email", className: (0, classnames_1.default)("form-control", "allclass", {
                        "border-red": formik.touched.emailForRef && formik.errors.emailForRef,
                    }), placeholder: t.input.placeholder, maxLength: 150, id: "emailForRef", tabIndex: 1 }, formik.getFieldProps("emailForRef"))),
                formik.touched.emailForRef && formik.errors.emailForRef && (react_1.default.createElement("span", { className: "errors error-email-correct", style: { position: "relative", top: 0 } },
                    t.validation[formik.errors.emailForRef],
                    react_1.default.createElement("i", { className: "fa fa-exclamation-circle", "aria-hidden": "true", style: { marginLeft: "5px" } })))),
            react_1.default.createElement(buttons_1.Button, { type: "submit", variant: "rounded" }, t.button))));
};
exports.RefProgramPopUp = RefProgramPopUp;
